import store from "@src/reducers/store";
import apiUseCases from "../api";

export interface GetLatestTimeseriesDataResult {
  success: boolean;
  data?: unknown;
  error?: string;
  status?: number;
}

export interface GetLatestTimeseriesDataUseCaseParams {
  group: string;
  source: string;
  days?: number;
  duration?: string;
  frequency?:
    | "raw"
    | "quarterhourly"
    | "hourly"
    | "daily"
    | "weekly"
    | "monthly"
    | "yearly";
  sortorder?: "ASC" | "DESC";
  limit?: number;
  limit_order?: "ASC" | "DESC";
  show_missing?: boolean;
}

export const getQueryLastTimeseriesByMetadataUseCase = async ({
  group,
  source,
  days,
  duration,
  frequency,
  sortorder,
  limit,
  limit_order,
  show_missing,
}: GetLatestTimeseriesDataUseCaseParams): Promise<GetLatestTimeseriesDataResult> => {
  const namespace = store.getState().yourSlice.authContext.customerNamespace;

  const response = await apiUseCases.getQueryLastTimeseriesByMetadataAPI({
    namespace,
    group,
    source,
    days,
    duration,
    frequency,
    sortorder,
    limit,
    limit_order,
    show_missing,
  });

  if (!response.success) {
    return {
      success: false,
      error: response.error,
      status: response.status,
    };
  }

  return {
    success: true,
    data: response.data,
  };
};
